var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarburst(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5386 15.6055L12.8765 23.2236C12.5927 23.2451 12.3063 23.2607 12.0171 23.2607C11.8717 23.2607 11.7266 23.2545 11.5825 23.249L15.3257 15.5166C15.3952 15.5491 15.4658 15.5793 15.5386 15.6055Z",
    fill: "#00B6C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7075 15.1113L8.09521 22.5566C7.58529 22.3672 7.09257 22.1429 6.62061 21.8848L14.5122 14.917C14.574 14.9852 14.6388 15.0501 14.7075 15.1113Z",
    fill: "#00B6C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9897 14.0322C14.0233 14.1303 14.0631 14.2251 14.1079 14.3174L3.56299 19.4355C3.18039 19.0009 2.83079 18.537 2.51807 18.0469L13.9897 14.0322Z",
    fill: "#00B6C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8579 13.0439C13.8545 13.0976 13.8501 13.1516 13.8501 13.2061C13.8501 13.2863 13.8546 13.366 13.8618 13.4443L0.965332 14.168C0.854345 13.5991 0.786966 13.015 0.765137 12.4189L13.8579 13.0439Z",
    fill: "#00B6C8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0835 12.1455C14.0405 12.2393 14.0008 12.3351 13.9692 12.4346L1.46533 8.05957C1.68107 7.48208 1.94322 6.92752 2.24658 6.39941L14.0835 12.1455Z",
    fill: "#00B6C8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6772 11.3291C14.6084 11.3924 14.5425 11.4588 14.481 11.5293L5.021 3.17676C5.49628 2.7994 6.00248 2.4598 6.53564 2.16211L14.6772 11.3291Z",
    fill: "#00B6C8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.519 10.8135C15.4443 10.8411 15.3715 10.8721 15.3003 10.9062L10.4341 0.850586C10.9457 0.778614 11.4682 0.73907 11.9995 0.738281L15.519 10.8135Z",
    fill: "#00B6C8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9126 22.1424C16.5772 22.3046 16.2324 22.45 15.8794 22.5789L16.313 15.7537C16.3427 15.7547 16.3729 15.7586 16.4028 15.7586C16.4428 15.7586 16.4824 15.7536 16.522 15.7517L16.9126 22.1424Z",
    fill: "#1D384C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7446 20.1853C19.5161 20.4011 19.2787 20.6072 19.0327 20.8035L17.2495 15.6101C17.3101 15.5888 17.3698 15.5665 17.4282 15.5408L19.7446 20.1853Z",
    fill: "#1D384C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5903 17.9275C21.4502 18.1533 21.3013 18.3729 21.146 18.5877L18.1626 15.1551V15.0506C18.1993 15.0155 18.2345 14.9793 18.269 14.9422L21.5903 17.9275Z",
    fill: "#1D384C"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7134 15.5174C22.6371 15.7493 22.554 15.9779 22.4634 16.2029L18.6626 14.3875C18.7037 14.309 18.741 14.2284 18.7739 14.1453L22.7134 15.5174Z",
    fill: "#1D384C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2349 12.9353C23.215 13.1771 23.1897 13.4168 23.1548 13.6541L18.9458 13.3777C18.9496 13.321 18.9546 13.2635 18.9546 13.2058C18.9546 13.1668 18.9505 13.1282 18.9487 13.0896L23.2349 12.9353Z",
    fill: "#1D384C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.105 10.0447C23.1521 10.3135 23.1926 10.5851 23.2202 10.8601V10.8621L18.8198 12.3933C18.7906 12.3065 18.7572 12.2218 18.7192 12.1394L23.105 10.0447Z",
    fill: "#1D384C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.063 6.91384C22.1643 7.11361 22.2615 7.31584 22.3511 7.52224L22.4526 7.85427L18.3403 11.5486C18.2898 11.4896 18.2378 11.4319 18.1821 11.3777L22.063 6.91384Z",
    fill: "#1D384C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7095 3.77908C20.0168 4.06676 20.308 4.37095 20.5815 4.69118L17.4858 10.8972C17.423 10.8677 17.359 10.8406 17.2935 10.8162L19.7095 3.77908Z",
    fill: "#1D384C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7134 1.36208C16.1782 1.5236 16.6291 1.71394 17.064 1.9324L16.5308 10.6599C16.4883 10.6578 16.4458 10.6541 16.4028 10.6541C16.3699 10.6541 16.3368 10.6567 16.3042 10.658L15.7134 1.36208Z",
    fill: "#1D384C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarburst);
export default __webpack_public_path__ + "static/media/Starburst.9edc7365c61d6af371f3bc9b9cb1714e.svg";
export { ForwardRef as ReactComponent };